// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__19Ech","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1B8CN"};